module.exports = __webpack_public_path__ + "img/5.7d0bef2b.jpg";